
import $ from "jquery";

$(function(){
    // burger navigation
    if ( $('#burger').length ){
        let menuOpen = false;
        const toggleMenu = function(){
            menuOpen = !menuOpen;
            $('nav#mainnav').toggleClass('open');
            $('nav#mainnav > ul').slideToggle(300);

            // open all active menu levels (the li with .active on it)
            let $activeSubNavs = $('nav#mainnav li.active > svg');
            if (!$activeSubNavs.length) $activeSubNavs = $('li.firstLevel:first-child > svg, li.firstLevel:first-child li.hasSub:first > svg');
            $activeSubNavs.click();
            // $activeSubNavs.each(el => $(el).click());
        };
        $('#burger').on('click', function(e) {
            e.stopPropagation();
            toggleMenu();
        });
        $(document).on('click', function(e) {
            const $mainnav = $('#mainnav');
            if(!$mainnav.is(e.target) && $mainnav.has(e.target).length === 0 && menuOpen) {
                toggleMenu();
            }
        });
        $('li.firstLevel > svg').on('click', function(){
            if ( !$(this).parent().hasClass('open') && $('li.firstLevel.open').length ){
                $('li.firstLevel.open ul').slideUp(300);
                $('li.firstLevel.open').removeClass('open');
            }
            $(this).next('ul').slideToggle(300);
            $(this).parent().toggleClass('open');
        });
        $('li.hasSub > svg').on('click', function(){
            if ( !$(this).parent().hasClass('open') && $('li.hasSub.open').length ){
                $('li.hasSub.open ul').slideUp(300);
                $('li.hasSub.open').removeClass('open');
            }
            $(this).next('ul').slideToggle(300);
            $(this).parent().toggleClass('open');
        });
    }

    $('a.target-blank').each(function() {
       $(this).attr('target', '_blank');
    });

});// document ready